<template>
    <div :class="wrapClasses">
        <template v-if="type !== 'textarea'">
            <!--前置元素-->
            <div :class="[prefixCls + '-group-prepend']" v-if="prepend" v-show="slotReady">
                <slot name="prepend"></slot>
            </div>

            <!--前置内容-->
            <!--后置内容-->
            <span :class="[`${burgeonConfig.prefixCls}input-innerWrap`,append ? `${burgeonConfig.prefixCls}input-inner` : '',]"
                  v-if="!append"
            >
                <!--1,功能类可以重复，展示类不可重复-->
                <!--清除clearable-->
                <i v-if="clearable && currentValue"
                   :class="[
                       burgeonConfig.prefixCls+'icon',
                       burgeonConfig.prefixCls+'iconios-close-circle iconfont iconios-close-circle',
                       prefixCls + '-icon',
                       prefixCls + '-icon-clear',
                       prefixCls + '-icon-normal'
                   ]"
                   ref="clearIcon"
                   @click="handleClear"
                ></i>

                <!--2,展示类-->
                <!--icon带Icon的输入框-->
                <i v-if="icon"
                   :class="[
                        burgeonConfig.prefixCls+'icon',
                        burgeonConfig.prefixCls+'icon-'+icon+' iconfont icon' + icon,
                        prefixCls + '-icon',
                        prefixCls + '-icon-normal'
                    ]"
                   @click="handleIconClick"
                ></i>
                <!--loading-->
                <transition name="fade">
                    <i
                        :class="[
                            burgeonConfig.prefixCls+'icon',
                            burgeonConfig.prefixCls+' iconfont iconios-loading',
                            burgeonConfig.prefixCls+'load-loop',
                            prefixCls + '-icon',
                            prefixCls + '-icon-validate'
                        ]"
                        v-if="!icon"></i>
                </transition>
            </span>

            <!--value气泡框-->
            <input
                   :id="elementId"
                   :autocomplete="autocomplete"
                   :spellcheck="spellcheck"
                   ref="input"
                   type="text"
                   :class="inputClasses"
                   :placeholder="__disablePlaceholder__ ? undefined : placeholder"
                   :disabled="disabled"
                   :readonly="readonly"
                   :name="name"
                   :number="number"
                   :autofocus="autofocus"
                   :value="currentValue"
                   @click="handleClick">
            <!--后置元素-->
            <div v-if="append" :class="[prefixCls + '-group-append']" ref="append" v-show="slotReady">
                <slot name="append"></slot>
            </div>
            <!--头部图标-->
            <span v-else-if="showPrefix"
                  :class="[
                    burgeonConfig.prefixCls+'input-prefix',
                    showPrefix
                  ]">
                <slot name="prefix">
                    <i :class="[burgeonConfig.prefixCls+'icon',burgeonConfig.prefixCls+' icon' + prefix,prefix]"
                       v-if="prefix"></i>
                </slot>
            </span>
        </template>

        <!--modal-->
        <Modal v-model="modelOpen" title="批量操作" mask>
            <div>
                <Input
                    v-model="enterVal"
                    type="textarea"
                    :rows="3"
                    placeholder="Enter something..."
                    @on-enter="handleModelEnter"
                />
                <p :class="tipCls">当前数据：{{valueList.length || 0}}条</p>
                <div :class="bodyCls">
                    <div :class="wrapCls" v-if="!copyNow">
                        <div :class="itemCls" v-for="(item, idx) in valueList">
                            <span :class="itemTxtCls" :title="item">{{item}}</span>
                            <Icon @click="() => del(item, idx)" type="ios-close" />
                        </div>
                    </div>
                    <div :class="wrapCls" v-else ref="copy">{{valueList.join(splitStr || ',')}}</div>

                    <div :class="toolsCls">
                        <Button type="fcdefault" @click="copyAll" :disabled="valueList.length <= 0">一键复制</Button>
                        <Button type="fcdefault" @click="handleModalClear">清空</Button>
                    </div>

                </div>
            </div>

            <div slot="footer">
                <Button @click="handleModalClose">关闭</Button>
            </div>
        </Modal>

    </div>
</template>
<script>
/* eslint-disable no-lonely-if,prefer-destructuring */

import {findComponentUpward, oneOf} from '../../utils/assist';
import calcTextareaHeight from '../../utils/calcTextareaHeight';
import Message from '../message/index';
import Emitter from '../../mixins/emitter';
import {t} from '../../locale/index';


import burgeonConfig from '../../assets/config';
import fkdialog from '../../../examples/routers/fkdialog';

const prefixCls = `${burgeonConfig.prefixCls}input`;
const prefixModalCls = `${burgeonConfig.prefixCls}input-compressed`;

export default {
    name: 'InputCompressed',
    mixins: [Emitter],
    components: { Message },
    props: {
        __disableInputEvent__: {
            default: false
        },
        __disablePlaceholder__: {
            default: false
        },
        type: {
            validator(value) {
                return oneOf(value, ['number', 'string']);
            },
            default: 'number'
        },
        value: {
            type: [String, Number],
            default: ''
        },
        size: {
            validator(value) {
                return oneOf(value, ['small', 'large', 'default']);
            },
            default() {
                return !this.$IVIEW || this.$IVIEW.size === '' ? 'default' : this.$IVIEW.size;
            }
        },
        placeholder: {
            type: String,
            default: () => t('i.input.inputPlaceholder')
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {type: String, default: 'ios-more-outline'},
        autosize: {
            type: [Boolean, Object],
            default: false
        },
        rows: {
            type: Number,
            default: 2
        },
        readonly: {
            type: Boolean,
            default: false
        },
        name: {
            type: String
        },
        number: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        spellcheck: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            validator(value) {
                return oneOf(value, ['on', 'off', 'new-password']);
            },
            default: 'off'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        elementId: {
            type: String
        },
        wrap: {
            validator(value) {
                return oneOf(value, ['hard', 'soft']);
            },
            default: 'soft'
        },
        prefix: {
            type: String,
            default: ''
        },
        splitStr: {
            type: String,
            default: ','
        }

    },
    model: {
        event: 'on-input-model'
    },
    data() {
        return {
            // 控制弹窗展示
            modelOpen: false,
            valueList: [],
            enterVal:'',
            copyNow:false,


            unselectable: '',
            compositionBefore: '',
            compositionValue: '',
            beforeEmitModelValue: '',
            currentValue: this.value,
            prefixCls: prefixCls,
            burgeonConfig: burgeonConfig,
            prepend: true,
            append: true,
            slotReady: false,
            textareaStyles: {},
            showPrefix: false,
            showSuffix: false,
            inputEvent: {},
            isNumber: false,
            chinese: false,
            pasteRegex: false,
            isIEclass: false
        };
    },
    computed: {
        showValue() {
            // return this.value.replace(/,/g,',\n');
            // return this.value.split(',').map(v => ({ value: v }));
            return this.value.split(',');
        },
        wrapCls() {
            return [
                `${prefixModalCls}-wrap`
            ];
        },
        itemCls() {
            return [
                `${prefixModalCls}-item`
            ];
        },
        tipCls() {
            return [
                `${prefixModalCls}-tip`
            ];
        },
        bodyCls() {
            return `${prefixModalCls}-body`;
        },
        toolsCls() {
            return `${prefixModalCls}-tools`;
        },
        itemTxtCls() {
            return `${prefixModalCls}-item-txt`;
        },

        // textare加密文本
        encryptedTextArea() {
            return this.currentValue.replace(/./g, '·');
        },
        // 是否是加密的textarea
        isEncryptedTextarea() {
            return this.encrypt && this.type === 'textarea';
        },
        getReadonlyValue() {
            if (!!window.ActiveXObject || 'ActiveXObject' in window && this.disabled) { //判断是否是IE 11及以下或者其他(其他里包括IE edge)
                this.unselectable = 'on';
                return true;
            } else {
                this.isIEclass = false;
                this.unselectable = '';
                return this.readonly;
            }
        },
        getDisabledValue() {
            if (!!window.ActiveXObject || 'ActiveXObject' in window) { //判断是否是IE 11及以下或者其他(其他里包括IE edge)
                if (this.disabled) {
                    this.isIEclass = true;
                }

            } else {
                this.isIEclass = false;
            }
            return this.disabled;
        },
        wrapClasses() {
            return [
                `${prefixCls}-wrapper`,
                {
                    [`${prefixCls}-wrapper-${this.size}`]: !!this.size,
                    [`${prefixCls}-type`]: this.type,
                    [`${prefixCls}-group`]: this.prepend || this.append || (this.search && this.enterButton),
                    [`${prefixCls}-group-${this.size}`]: (this.prepend || this.append || (this.search && this.enterButton)) && !!this.size,
                    [`${prefixCls}-group-with-prepend`]: this.prepend,
                    [`${prefixCls}-group-with-append`]: this.append || (this.search && this.enterButton),
                    [`${prefixCls}-hide-icon`]: this.append, // #554
                    [`${prefixCls}-with-search`]: this.search && this.enterButton
                }
            ];
        },
        inputClasses() {
            return [
                `${prefixCls}`,
                {
                    [`${prefixCls}-${this.size}`]: !!this.size,
                    [`${prefixCls}-disabled`]: this.disabled,
                    [`${prefixCls}-disabledHidden`]: this.disabled && this.disabledHidden,
                    [`${prefixCls}-with-prefix`]: this.showPrefix,
                    [`${prefixCls}-with-suffix`]: this.showSuffix || (this.search && this.enterButton === false)
                }
            ];
        },
        textareaClasses() {
            return [
                `${prefixCls}`,
                {
                    [`${prefixCls}-disabled`]: true
                },
                {
                    [`${prefixCls}-textarea-limit`]: this.wordLimit
                }
            ];
        },
        isWordLimitVisible() {
            return this.wordLimit
                && this.maxlength
                && (this.type === 'text' || this.type === 'textarea')
                && !this.readonly;
        },
        upperLimit() {
            return this.maxlength;
        },
        textLength() {
            if (typeof this.value === 'number') {
                return String(this.value).length;
            }
            return (this.value || '').length;
        }
    },

    updated() {
        const {customData} = this;
        if (customData && Object.prototype.toString.call(customData) === '[object Object]') {
            Object.keys(customData).forEach((key) => {
                if (Object.keys(this.$props).indexOf(key) === -1) {
                    this[key] = customData[key];
                }
            });
        }
        this.$nextTick(this.updateIconOffset);
    },
    created() {
        this.updateVmodel();
    },

    mounted() {
        setTimeout(() => {
            if (this.autofocus) {
                this.focus();
            }

        }, 100);
        if (this.type !== 'textarea') {
            this.prepend = this.$slots.prepend !== undefined;
            this.append = this.$slots.append !== undefined;
            this.showPrefix = this.prefix !== '' || this.$slots.prefix !== undefined;
            this.showSuffix = this.suffix !== '' || this.$slots.suffix !== undefined;
        } else {
            this.prepend = false;
            this.append = false;
        }
        let that = this;
        if (this.$refs.input) {
            this.$refs.input.addEventListener('paste', (event) => {
                this.pasteRegex = true;
                setTimeout(() => {
                    if (this.regx && !this.regx.test(event.target.value)) {
                        this.pasteRegex = true;
                        event.target.value = '';
                        this.$emit('on-input-model', '');
                        this.currentValue = '';
                        this.pasteRegex = false;
                    } else {
                        this.pasteRegex = false;
                    }
                    this.handleInput(event);
                }, 0);
            });
            this.$refs.input.addEventListener('compositionstart', (event) => {
                that.chinese = true;
            });
            this.$refs.input.addEventListener('compositionend', (event) => {
                that.chinese = false;
                if (that.regx && !that.regx.test(event.target.value)) {
                    event.target.value = that.value;
                    return false;
                }
                if (that.number) {
                    event.target.value = that.value;
                    return false;
                }
                that.handleInput(event);
            });


        }
        this.slotReady = true;
        this.resizeTextarea();
        this.getClearIconStyle();
        setTimeout(() => {
            this.updateIconOffset();
        }, 100);
    },
    watch: {
        value(val, old) {
            if (val !== old || (val && !old)) {
                this.updateVmodel();
            }
        },
    },

    methods: {
        setValue(val) {
            this.valueList = val ? val.split(this.splitStr) : [];
            this.currentValue = val;
            this.$emit('input', val, this);
            this.$emit('on-input-model', val);
        },
        // input methods
        handleClick(e) {
            this.modelOpen = true;
        },
        updateVmodel() {
            const {value} = this;
            const handleVal = value && value.split(this.splitStr);
            this.valueList = this.validData(handleVal);
        },

        // modal methods
        handleModalClear() {
            this.setValue();
        },
        handleModalClose() {
            this.modelOpen = false;
        },
        del(e, i) {
            let tempList = JSON.parse(JSON.stringify(this.valueList));
            tempList = [...tempList.slice(0, i), ...tempList.slice(i + 1, tempList.length)];
            this.valueList = tempList;
            const value = this.valueList && this.valueList.length > 0 ? this.valueList.join(this.splitStr) : '';
            this.setValue(value);
        },
        handleModelEnter(event) {
            let val = event.target.value;
            const oldArr = this.filterValidData(val.split(this.splitStr));
            const newArr = this.validData(oldArr.concat(...this.valueList));
            console.log('newArr', newArr);
            this.valueList = newArr;
            this.enterVal = '';
            // 处理最终数据str
            const value = this.valueList && this.valueList.length > 0 ? this.valueList.join(this.splitStr) : '';
            this.setValue(value);
        },
        filterValidData(arr) {
            // 校验去重
            if (this.type === 'string') {
                return arr.filter(v => v);
            }
            return arr.filter(v => v && Number(v)).map(k => Number(k));
        },
        copyAll() {
            const currentStr = this.valueList.join(this.splitStr || ',');
            // this.copy();
            console.log('currentStr', currentStr);
            this.copy(currentStr);
        },
        async copy(str) {
            const self = this;
            if (navigator && navigator.clipboard) {
                try {
                    await navigator.clipboard.writeText(str);
                    Message.success({
                        content: '复制成功！'
                    });
                } catch (err) {
                    console.error('Failed to copy: ', err);
                }
                return;
            }
            this.copyNow = true;
            this.$nextTick(() => {
                const ele = this.$refs.copy;
                if (ele) {
                    window.getSelection().selectAllChildren(ele);
                    try {
                        document.execCommand('copy', false, null);
                        Message.success({
                            content: '复制成功！',
                            onClose: () => self.copyNow = false
                        });
                    } catch (err){
                        console.error('Failed to copy: ', err);
                    }
                }
            })


            // this.$Modal.info({
            //     render: (h, params) => h('p', {
            //         attrs: {
            //             id: 'copy'
            //         }
            //     }, str),
            //     footerRender: () => null
            // });
        },
        // 数据整理
        validData(arr) {
            return Array.from(new Set(arr)).map(v => Number(v));
        },


        handleCompositionStart(e) {
            this.chinese = true;
            this.compositionBefore = e.target.value;
            if (this.isEncryptedTextarea && e.target.selectionStart !== e.target.selectionEnd) {
                this.isSelectedText = true;
                this.selectionStartOfSelectedText = e.target.selectionStart;
                this.selectedText = window.getSelection().toString();
            }
        },
        handleCompositionEnd(e) {
            if (this.isEncryptedTextarea && !e.data) {
                // 值没变化时就显示之前的密文
                e.target.value = this.encryptedTextArea;
                this.chinese = false;
                return;
            }
            if (this.isEncryptedTextarea && e.data) {
                this.selectionStart = e.target.selectionStart;
                const offset = Math.max(e.data.length - 1, 0); // 每多一个中文会导致光标偏移一位，所以要减掉
                const selectionStart = e.target.selectionStart - offset - 1; // 粘贴时，按下键盘时的光标位置为准
                let value = '';

                // 输入的值覆盖已选文本的情况
                if (this.isSelectedText && e.data) {
                    this.selectionStart = this.selectionStartOfSelectedText + e.data.length;

                    const charArr = this.oldValue.split('');
                    charArr.splice(this.selectionStartOfSelectedText, this.selectedText.length, e.data);
                    value = charArr.join('');

                    this.isSelectedText = false;
                } else {
                    const charArr = this.oldValue.split('');
                    charArr.splice(selectionStart, 0, e.data);
                    value = charArr.join('');
                }

                this.oldValueArr.push({
                    value: this.currentValue,
                    selectionStart: e.target.selectionStart
                });
                // 这个判断这为了修复--输入一个中文拼音然后删除，会导致之前输入字符显示明文
                if (value !== this.currentValue) {
                    e.target.value = value;
                    this.$emit('on-input-model', value);
                    this.$emit('on-change', e, this);
                }
            }
            this.chinese = false;
            // 抛出v-model
            if (!this.isEncryptedTextarea) {
                this.$emit('on-input-model', e.target.value);
                this.$emit('on-change', e, this);
            }
            if (this.__disableInputEvent__) {
                this.compositionValue = e.target.value.replace(this.compositionBefore, '');
                e.target.value = e.target.value.replace(this.compositionValue, '');
            }
        },
        handleEnter(event) {
            this.$emit('on-enter', event, this);
            if (this.search) {
                this.$emit('on-search', this.currentValue, this);
            }
        },
        // 剪切
        handlePaste(e) {
            if (this.isEncryptedTextarea) {
                const clipboardData = e.clipboardData;
                this.keyData = clipboardData.getData('text');
                this.selectionStartOfPaste = e.target.selectionStart;

                // 是否是粘贴覆盖已选中的文本
                if (e.target.selectionStart !== e.target.selectionEnd) {
                    this.isSelectedText = true;
                    this.selectionStartOfSelectedText = e.target.selectionStart;
                }
                this.isPaste = true;
            }
            this.$emit('paste', e);
        },

        handleKeydown(event) {
            if (this.isEncryptedTextarea) {
                const ctrlKey = 17;
                const cmdKey = 91;
                let keyData = event.key;
                this.keyCode = event.keyCode;
                // 按下回车
                if (this.keyCode === 13) {
                    keyData = '\n';
                }
                // 是否按下控制按钮
                if (event.keyCode === ctrlKey || event.keyCode === cmdKey) {
                    this.isPressControl = true;
                }
                // 是否按下撤销
                if (this.isPressControl && this.keyCode === 90) {
                    this.isPressUndo = true;
                }

                this.selectionStartOfKeyDown = event.target.selectionStart;
                this.oldValue = this.currentValue;
                this.keyData = keyData;

                // 判断是否选中了部分文本
                if (event.target.selectionStart !== event.target.selectionEnd) {
                    this.selectedText = window.getSelection().toString();
                    this.isSelectedText = true;
                    this.selectionStartOfSelectedText = event.target.selectionStart;
                }
            }
            this.$emit('on-keydown', event, this);
        },
        handleKeypress(event) {
            this.$emit('on-keypress', event, this);
        },
        handleKeyup(event) {
            if (this.isEncryptedTextarea) {
                const ctrlKey = 17;
                const cmdKey = 91;
                if (event.keyCode === ctrlKey || event.keyCode === cmdKey) {
                    this.isPressControl = false; // 是否按下控制按钮
                    this.isPressUndo = false; // 是否按下撤销按钮
                }
            }
            this.$emit('on-keyup', event, this);
        },
        handleIconClick(event) {
            this.handleClick();
            this.$emit('on-click', event, this);
        },
        handleFocus(event) {
            this.$emit('on-focus', event, this);
        },
        handleBlur(event) {
            // console.log('event', event)
            // console.log('this', this)
            // let value = event.target.value && event.target.value.trim();
            // if (this.trim) {
            //     this.currentValue = value;
            //     this.setCurrentValue(value);
            //     this.$emit('input', event.target.value, this);
            //     this.$emit('on-input-model', value);
            // }
            if (this.number) {
                if (event.target.value) {
                    event.target.value = Number(event.target.value);
                    this.$emit('on-change', event, this);
                }
            }
            if (this.htmlExp) {
                if (event.target.value) {
                    event.target.value = htmlEncodeByRegExp(event.target.value);
                    this.$emit('on-change', event, this);
                }
            }
            this.$emit('on-blur', event, this);
            if (!findComponentUpward(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
                this.dispatch('FormItem', 'on-form-blur', this.currentValue);
            }
        },
        handleInput(event) {
            if (this.pasteRegex) {
                return false;
            }
            if (this.chinese) {
                return false;
            }
            // 修复：失去焦点后按撤销会导致加密文本变明文
            if (document.activeElement !== event.target) {
                return false;
            }
            // 非撤销操作进行缓存
            if (this.isEncryptedTextarea && !this.isPressUndo) {
                this.oldValueArr.push({
                    value: this.currentValue,
                    selectionStart: event.target.selectionStart
                });
            }

            this.$emit('input', event.target.value, this);

            if (this.regx) {
                if (this.number) {
                    if (event.target.value) {
                        let val = event.target.value;
                        if (!this.regx.test(event.target.value)) {
                            event.target.value = this.currentValue;
                            this.$emit('on-regx-check', event.target.value, this, val);
                        }
                        this.beforeEmitModelValue = event.target.value;
                        if (Number.isNaN(Number(event.target.value))) {
                            event.target.value = '';
                            this.$emit('on-input-model', 0);
                            this.currentValue = event.target.value;
                        } else {
                            this.$emit('on-input-model', Number(event.target.value));
                            this.currentValue = event.target.value;
                        }
                        !this.isEncryptedTextarea && this.$emit('on-change', event, this);
                    } else if (event.target.value === '') {
                        this.$emit('on-input-model', event.target.value);
                        !this.isEncryptedTextarea && this.$emit('on-change', event, this);
                    }
                } else {
                    let val = event.target.value;
                    if (val && !this.regx.test(event.target.value)) {
                        if (event.target.value && event.target.value.indexOf('……') > -1) {
                            event.target.value = event.target.value.replace('……', '');
                        } else {
                            event.target.value = this.currentValue;
                        }
                        this.$emit('on-regx-check', event.target.value, this, val);
                    }
                    this.$emit('on-input-model', event.target.value);
                    this.currentValue = event.target.value;
                    !this.isEncryptedTextarea && this.$emit('on-change', event, this);
                }
            } else {
                let value = event.target.value;
                if (this.number && value !== '') {
                    value = Number.isNaN(Number(value)) ? value : Number(value);
                }
                this.$emit('on-input-model', value);
                this.setCurrentValue(value);
                !this.isEncryptedTextarea && this.$emit('on-change', event, this);
            }

            // 加密textarea
            if (this.isEncryptedTextarea) {
                this.selectionStart = event.target.selectionStart;
                const selectionStart = this.isPaste ? this.selectionStartOfPaste + 1 : this.selectionStart; // 粘贴时，按下键盘时的光标位置为准

                // 按下撤销
                if (this.isPressUndo) {
                    const oldValue = this.oldValueArr.pop();
                    this.selectionStart = oldValue.selectionStart;
                    event.target.value = oldValue.value;
                    this.$emit('on-input-model', oldValue.value);
                    this.$emit('on-change', event, this);
                    this.isPaste = false;
                    return false;
                }

                // 覆盖已选文本的情况(没有按删除键的情况下)
                if (this.isSelectedText && this.keyCode !== 8) {
                    this.selectionStart = this.selectionStartOfSelectedText + this.keyData.length;
                    // 先删除再粘贴
                    const charArr = this.oldValue.split('');
                    charArr.splice(this.selectionStartOfSelectedText, this.selectedText.length, this.keyData);
                    event.target.value = charArr.join('');

                    this.$emit('on-input-model', charArr.join(''));
                    this.$emit('on-change', event, this);
                    this.isPaste = false;
                    this.isSelectedText = false;
                    return false;
                }

                // 手动把新加的输入值和原来的值进行拼接
                let charArr = this.oldValue.split('');
                if (event.target.value.length >= this.oldValue.length) {
                    // 输入值
                    charArr.splice(selectionStart - 1, 0, this.keyData);
                } else if (event.target.value.length < this.oldValue.length && event.target.value !== '') {
                    // 删除
                    charArr.splice(selectionStart, this.oldValue.length - event.target.value.length);
                } else {
                    // 全选删除
                    charArr = [];
                }
                event.target.value = charArr.join('');
                this.$emit('on-input-model', charArr.join(''));
                this.$emit('on-change', event, this);

                this.isPaste = false;
                this.isSelectedText = false;
            }
        },
        handleChange(event) {
            this.$emit('on-input-change', event, this);
        },
        setCurrentValue(value) {
            if (value === this.currentValue) {
                return;
            }
            this.$nextTick(() => {
                this.resizeTextarea();
            });
            this.currentValue = value;
            if (!findComponentUpward(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
                this.dispatch('FormItem', 'on-form-change', value);
            }
        },
        resizeTextarea() {
            const autosize = this.autosize;

            if (!autosize || this.type !== 'textarea') {
                return false;
            }

            const minRows = autosize.minRows;
            const maxRows = autosize.maxRows || this.rows;

            this.textareaStyles = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
        },
        focus() {
            if (this.type === 'textarea') {
                this.$refs.textarea.focus();
            } else {
                this.$refs.input.focus();
            }
        },
        blur() {
            if (this.type === 'textarea') {
                this.$refs.textarea.blur();
            } else {
                this.$refs.input.blur();
            }
        },
        handleClear() {
            const e = {target: {value: ''}};
            this.$emit('on-input-model', '');
            this.$emit('input', '', this);
            this.setCurrentValue('');
            this.$emit('on-clear', e, this);
            this.$emit('on-change', e, this);
        },
        getClearIconStyle() {
            this.$nextTick(() => {
                if (this.append) {
                    let paddingRight = this.$refs.append.offsetWidth;
                    if (this.$refs.clearIcon) {
                        this.$refs.clearIcon.style['margin-right'] = `${paddingRight}px`;
                    }
                }
            });
        },

        calcIconOffset(place) {
            let elList = [].slice.call(this.$el.querySelectorAll('.ark-input-prefix') || []);
            if (!elList.length) {
                return;
            }
            let el = null;
            for (let i = 0; i < elList.length; i++) {
                if (elList[i].parentNode === this.$el) {
                    el = elList[i];
                    break;
                }
            }
            if (!el) {
                return;
            }
            const pendantMap = {
                suffix: 'append',
                prefix: 'prepend'
            };

            const pendant = pendantMap[place];
            if (this.$slots[pendant]) {
                el.style.transform = `translateX(${place === 'suffix' ? '-' : ''}${this.$el.querySelector(`.ark-input-group-${pendant}`).offsetWidth}px)`;
                el.style.zIndex = 2;
            } else {
                el.removeAttribute('style');
            }
        },
        updateIconOffset() {
            this.calcIconOffset('prefix');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/input-compressed/input-compressed.vue